import { AnimateMotion } from "@/components/AnimateMotion";
import { VisualArea as VisualAreaWrapper } from "@/components/layout/VisualArea";

function ModelSidebar({ children }: { children: React.ReactNode }) {
    return (
        <div className="relative flex h-full w-[340px] flex-shrink-0 flex-col p-6 pl-0">
            <div className="shadow-soft relative flex h-full flex-col overflow-hidden rounded-xl border border-gray-300 bg-white">
                <div className="sidebarBody">{children}</div>
            </div>
        </div>
    );
}

export function ModelLayout({
    Sidebar,
    VisualArea
}: {
    Sidebar?: React.ReactNode;
    VisualArea: React.ReactNode;
}) {
    return (
        <AnimateMotion className="h-full w-full bg-white">
            <div className="relative flex h-[calc(100vh-6rem)] flex-col">
                <div className="relative flex h-full w-full min-w-0 flex-col md:flex-row">
                    <div className="relative flex h-full min-w-0 flex-1 flex-col px-3 pb-1 md:p-0">
                        <div className="relative flex h-full min-w-0 flex-1">
                            <VisualAreaWrapper>{VisualArea}</VisualAreaWrapper>
                        </div>
                    </div>
                    {Sidebar && <ModelSidebar>{Sidebar}</ModelSidebar>}
                </div>
            </div>
        </AnimateMotion>
    );
}
